export const uk = {
    'preview-cancel': 'Скасувати',
    'preview-select': 'Вибрати'
};
